function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3125 15.8438H0.6875C0.584375 15.8438 0.5 15.9234 0.5 16.0219V17.4469C0.5 17.5453 0.584375 17.625 0.6875 17.625H15.3125C15.4156 17.625 15.5 17.5453 15.5 17.4469V16.0219C15.5 15.9234 15.4156 15.8438 15.3125 15.8438ZM8 14.0625C9.62656 14.0625 11.1547 13.4273 12.3078 12.2766C13.4609 11.1258 14.0938 9.59531 14.0938 7.96875V0.65625C14.0938 0.501563 13.9672 0.375 13.8125 0.375H12.4062C12.2516 0.375 12.125 0.501563 12.125 0.65625V7.96875C12.125 10.2422 10.2734 12.0938 8 12.0938C5.72656 12.0938 3.875 10.2422 3.875 7.96875V0.65625C3.875 0.501563 3.74844 0.375 3.59375 0.375H2.1875C2.03281 0.375 1.90625 0.501563 1.90625 0.65625V7.96875C1.90625 9.59531 2.54141 11.1234 3.69219 12.2766C4.84297 13.4297 6.37344 14.0625 8 14.0625Z",
  fill: "currentColor"
});

var SvgIcUnderline = function SvgIcUnderline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_underline.cfaaff4d.svg";
export { ForwardRef as ReactComponent };